<div class="details-top flex justify-content-between align-items-center mt-2">
  <div class="flex gap-2 align-items-center">
    <i
      class="pi pi-times secondary-button p-0 mr-2"
      (click)="closeDialog()"
    ></i>
    <button class="semiround-button" (click)="moveUp()" data-clarity-unmask="true">
      <i class="pi pi-angle-up"></i>
    </button>
    <button class="semiround-button" (click)="moveDown()" data-clarity-unmask="true">
      <i class="pi pi-angle-down"></i>
    </button>
    <span class="details-counter font-normal text-gray-800">
      {{ currentStudentIndex + 1 }} z
      {{ data.studentListPerPage.length }} wyników</span
    >
  </div>
  <p class="text-sm font-normal text-gray-500">
    Data utworzenia:
    {{
      data.studentListPerPage[currentStudentIndex].created | date: "dd.MM.yyyy"
    }}
  </p>
</div>

<ng-container>
  <div class="flex flex-column mt-3 md:mt-5 mb-3" [ngStyle]="{ 'min-height': '58px' }">
    <ng-container *ngIf="currentStudentDetails">
      <p class="font-normal text-bluegray-500">
        Ostatnie logowanie:
        {{ currentStudentDetails.lastLoginDate | date: "dd.MM.yyyy" }}
      </p>
      <div class="flex flex-wrap justify-content-between align-items-center">
        <div class="details-name flex align-items-center gap-3">
          <div class="font-semibold text-xl">
            {{ currentStudentDetails.displayName }}
          </div>
          <app-subscription-tag
            [bgColor]="
              currentStudentDetails.oskPlatformSubscriptionPlan?.bgColor ?? ''
            "
            [fgColor]="
              currentStudentDetails.oskPlatformSubscriptionPlan?.fgColor ?? ''
            "
            [planName]="
              currentStudentDetails.oskPlatformSubscriptionPlan?.planName ?? ''
            "
          ></app-subscription-tag>
        </div>
        <p-button
          *ngIf="canAdministerStudents"
          icon="pi pi-briefcase"
          label="Przydziel abonament"
          (onClick)="assignSubscription()"
          data-clarity-unmask="true"
        ></p-button>
      </div>
    </ng-container>
  </div>

  <p-tabView [activeIndex]="selectedTabIndex" (activeIndexChange)="onTabChange($event)">
    <p-tabPanel header="Dane podstawowe">
      <ng-container *ngIf="selectedTabIndex === 0">
        <form [formGroup]="studentDetailsForm">
          <div
            class="flex flex-wrap justify-content-between"
            [ngStyle]="{ 'min-height': '377px' }"
          >
            <ng-container *ngIf="oskStudentDetails$ | async as student">
              <ng-container
                *ngFor="let field of formFields"
                [ngSwitch]="field.name"
              >
                <div
                  *ngSwitchDefault
                  class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300 py-2 lg:w-25rem"
                  [ngStyle]="{ 'min-height': '54px' }"
                >
                  <label
                    [for]="field.name"
                    class="flex-none flex align-items-center w-10rem text-gray-500 font-normal text-sm"
                  >
                    {{ field.label }}
                  </label>
                  <div class="w-full flex align-items-center">
                    <p *ngIf="field.readonly">
                      {{
                        field.name === "created"
                          ? (student[field.name] | date: "dd.MM.yyyy")
                          : student[field.name]
                      }}
                    </p>
                    <input
                      *ngIf="!field.readonly"
                      [id]="field.name"
                      [type]="field.name === 'phone' ? 'tel' : 'text'"
                      pInputText
                      class="w-full"
                      [formControlName]="field.name"
                    />
                  </div>
                </div>
                <div
                  *ngSwitchCase="'examCategoryGuid'"
                  class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300 py-2 lg:w-25rem"
                  [ngStyle]="{ 'min-height': '54px' }"
                >
                  <label
                    [for]="field.name"
                    class="flex-none flex align-items-center w-10rem text-gray-500 font-normal text-sm"
                  >
                    {{ field.label }}
                  </label>
                  <div class="w-full flex align-items-center">
                    <p *ngIf="field.readonly" [class.text-gray-500]="!student.examCategoryName">
                      {{ student.examCategoryName || "Nie wybrano" }}
                    </p>
                    <p-dropdown
                      *ngIf="!field.readonly"
                      [inputId]="field.name"
                      class="w-full"
                      styleClass="w-full"
                      [options]="examCategoryOptions"
                      [formControlName]="field.name"
                      placeholder="Wybierz kategorię"
                      appendTo="body"
                    />
                  </div>
                </div>
                <div
                  *ngSwitchCase="'email'"
                  class="w-full flex flex-wrap justify-content-between align-items-center py-2 border-bottom-1 border-bluegray-300 mt-6"
                  [style]="{ 'padding-block': '12px' }"
                >
                  <div class="flex flex-wrap">
                    <label
                      [for]="field.name"
                      class="flex-none flex align-items-center w-11rem text-gray-500 font-normal text-sm"
                      >{{ field.label }}</label
                    >
                    <p>{{ student[field.name] }}</p>
                  </div>
                  <!-- <p-button label="Wyślij link aktywacyjny" icon="pi pi-send" (onClick)="sendActivationEmail()">
                  </p-button> -->
                </div>
              </ng-container>

              <div
                class="w-full flex flex-wrap justify-content-between align-items-center py-2 border-bottom-1 border-bluegray-300"
                [style]="{ 'padding-block': '12px' }"
              >
                <div class="flex flex-wrap">
                  <label
                    for="password"
                    class="flex-none flex align-items-center w-11rem text-gray-500 font-normal text-sm"
                    >Hasło</label
                  >
                  <p id="password">*****************</p>
                </div>
                <!-- <p-button label="Reset hasła" icon="pi pi-key" (onClick)="passwordReset()"></p-button> -->
              </div>
            </ng-container>
          </div>
        </form>
        <div class="form-decorator flex w-full align-items-center mt-4" *ngIf="currentStudentDetails">
          <div class="title">Prowadzący</div>
          <div class="form-wraper flex flex-wrap gap-2 align-items-center">
            <span *ngFor="let employee of currentStudentDetails.assignedEmployees ?? []" class="assigned-employee">
              {{ employee.displayName }}
              <small class="text-gray-500">{{ roleLabel(employee.role) }}</small>
              <i
                *ngIf="canAdministerStudents"
                class="pi pi-times cursor-pointer"
                pTooltip="Odepnij"
                tooltipPosition="top"
                (click)="!assigningTeacher && unassignTeacher(employee)"
              ></i>
            </span>
            <span *ngIf="!currentStudentDetails.assignedEmployees?.length" class="text-gray-500">
              Brak przypisanego instruktora i wykładowcy
            </span>
            <ng-container *ngIf="canAdministerStudents && availableTeacherOptions().length">
              <p-dropdown
                [options]="availableTeacherOptions()"
                [(ngModel)]="selectedTeacherGuid"
                placeholder="Wybierz instruktora lub wykładowcę"
                appendTo="body"
                styleClass="w-18rem"
              ></p-dropdown>
              <p-button
                label="Przypisz"
                icon="pi pi-user-plus"
                [outlined]="true"
                [disabled]="!selectedTeacherGuid || assigningTeacher"
                (onClick)="assignTeacher()"
                data-clarity-unmask="true"
              ></p-button>
            </ng-container>
          </div>
        </div>
        <div class="form-decorator flex w-full align-items-center mt-4" *ngIf="currentStudentDetails && canAdministerStudents">
          <div class="title">
            Dokumenty kursanta
          </div>
          <div class="form-wraper gap-2 flex flex-wrap">
            <p-button
              label="Pobierz umowę"
              icon="pi pi-file-pdf"
              [outlined]="true"
              [loading]="documentLoading === 'agreement'"
              [disabled]="documentLoading !== null"
              (onClick)="downloadAgreement()"
              data-clarity-unmask="true"
            ></p-button>
            <p-button
              label="Pobierz zgodę RODO"
              icon="pi pi-shield"
              [outlined]="true"
              [loading]="documentLoading === 'rodo'"
              [disabled]="documentLoading !== null"
              (onClick)="downloadRodo()"
              data-clarity-unmask="true"
            ></p-button>
          </div>
        </div>
        <section class="mt-6" *ngIf="canAdministerStudents">
          <p-button
            *ngIf="!editStudentDataMode"
            label="Edytuj dane kursanta"
            icon="pi pi-user"
            (onClick)="editStudentData()"
            data-clarity-unmask="true"
          ></p-button>
          <div *ngIf="editStudentDataMode" class="flex gap-3">
            <p-button
              label="Anuluj"
              (onClick)="cancelStudentDataChanges()"
              [outlined]="true"
              [disabled]="loading"
              data-clarity-unmask="true"
            >
            </p-button>
            <p-button
              label="Zapisz"
              icon="pi pi-save"
              (onClick)="updateStudentData()"
              [loading]="loading"
              [disabled]="studentDetailsForm.invalid"
              data-clarity-unmask="true"
            >
            </p-button>
          </div>
          <p
            class="my-3 text-sm text-bluegray-500"
            *ngIf="currentStudentDetails"
          >
          </p>
        </section>
      </ng-container>
    </p-tabPanel>

    <!-- <p-tabPanel header="Płatności">
      <fas-service-dynamic-table *ngIf="selectedTabIndex === 1" [columns]="studentPaymentsColumns" [dataMode]="'client'"
        [fullDataService]="fetchStudentPayments" [initialPageSize]="6" [isTransparentHeader]="true" [columnTemplates]="{
          paymentStatusTemp: paymentStatusTempRef
        }">
        <ng-template #paymentStatusTempRef let-row>
          <p [ngClass]="getStudentPaymentStatus(row).color">
            {{ getStudentPaymentStatus(row).label }}
          </p>
        </ng-template>
      </fas-service-dynamic-table>
    </p-tabPanel> -->

    <p-tabPanel header="Egzaminy">
      <ng-container *ngIf="selectedTabIndex === 1">
        <div *ngIf="hasStudentExamsData; else noDataMessage" class="student-exams">
          <fas-service-dynamic-table
            [columns]="studentExamColumns"
            [dataMode]="'client'"
            [fullDataService]="fetchStudentExams"
            [initialPageSize]="6"
            [isTransparentHeader]="true"
            [columnTemplates]="{
              examDateTemp: examDateTempRef,
              examActionsTemp: examActionsTempRef,
            }"
            [refreshCurrentPage]="refreshTable.asObservable()"
          >
            <ng-template #examDateTempRef let-row>
              <div class="flex align-items-center gap-2">
                <span>{{ row.end | date: "dd.MM.yyyy" }}</span>
                <span
                  *ngIf="hasInternalExamResult(row)"
                  class="internal-exam-status"
                  [class.internal-exam-status--passed]="
                    isPassed(row.internalExamResult)
                  "
                  [class.internal-exam-status--failed]="
                    isFailed(row.internalExamResult)
                  "
                  [pTooltip]="getInternalExamStatusLabel(row)"
                  tooltipPosition="top"
                >
                  <i
                    class="pi"
                    [ngClass]="
                      getInternalExamSourceIcon(row.internalExamSource)
                    "
                  ></i>
                </span>
              </div>
            </ng-template>
            <ng-template #examActionsTempRef let-row let-rowIndex="rowIndex">
              <ng-container *ngIf="isBoss">
              <button
                class="pi pi-eye cursor-pointer text-center appear transparent-button"
                pTooltip="Zobacz egzamin"
                tooltipPosition="bottom"
                (click)="showExam(row, rowIndex)"
                data-clarity-unmask="true"
              ></button>
              <button
                class="pi pi-calendar cursor-pointer text-center appear transparent-button"
                pTooltip="Zmień datę wykonania egzaminu"
                tooltipPosition="bottom"
                (click)="changeExamDate(row, rowIndex)"
                data-clarity-unmask="true"
              ></button>
              <button
                *ngIf="canMarkInternalExam(row)"
                class="pi cursor-pointer text-center appear transparent-button"
                [ngClass]="
                  isPassed(getManualResult(row))
                    ? 'pi-check-circle text-green-500'
                    : 'pi-times-circle text-red-500'
                "
                [pTooltip]="getManualResultTooltip(row)"
                tooltipPosition="bottom"
                (click)="markInternalExam(row)"
                data-clarity-unmask="true"
              ></button>
              </ng-container>
            </ng-template>
          </fas-service-dynamic-table>
        </div>
        <ng-template #noDataMessage>
          <p class="text-center text-muted">Brak egzaminów do wyświetlenia.</p>
        </ng-template>
      </ng-container>
    </p-tabPanel>

    <p-tabPanel header="Wykłady">
      <app-student-lectures *ngIf="selectedTabIndex === 2"
        [studentGuid]="data.studentListPerPage[currentStudentIndex].guid">
      </app-student-lectures>
    </p-tabPanel>

    <!-- Loaded on demand (I.10): the calendar dialogs stay out of this eagerly loaded module. -->
    <p-tabPanel *ngIf="canUseDrivingCalendar" header="Jazdy">
      <ng-container *ngIf="selectedTabIndex === 3 && drivingLessonsTab">
        <ng-container
          *ngComponentOutlet="
            drivingLessonsTab;
            inputs: {
              studentGuid: data.studentListPerPage[currentStudentIndex].guid,
              studentName: currentStudentDetails?.displayName,
            }
          "
        ></ng-container>
      </ng-container>
    </p-tabPanel>

    <p-tabPanel *ngIf="canAdministerStudents" header="Umowy">
      <app-student-agreements *ngIf="selectedTabIndex === 4"
        [studentGuid]="data.studentListPerPage[currentStudentIndex].guid"
        [studentName]="currentStudentDetails?.displayName"
        [examCategoryGuid]="currentStudentDetails?.examCategoryGuid">
      </app-student-agreements>
    </p-tabPanel>
  </p-tabView>
</ng-container>
